export async function slotCreateUseCase(slotData, slotRepository) {

    const result = await slotRepository.create(slotData);

    const entity = new slotRepository.model(result.data.success.arguments);
    
    if (!entity.isValid()) {
      throw new Error("Slot inválido");
    }

    return result;
}